/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AuditLog = {
    id?: number;
    userId?: string;
    userName?: string;
    userEmail?: string;
    userType?: string;
    action?: AuditLog.action;
    entityType?: string;
    entityId?: string;
    statusFrom?: string;
    statusTo?: string;
    oldValues?: Record<string, any>;
    newValues?: Record<string, any>;
    ipAddress?: string;
    userAgent?: string;
    timestamp?: string;
    details?: string;
};
export namespace AuditLog {
    export enum action {
        CREATE = 'CREATE',
        READ = 'READ',
        UPDATE = 'UPDATE',
        DELETE = 'DELETE',
        LOGIN = 'LOGIN',
        LOGOUT = 'LOGOUT',
        SHIP_REQUEST = 'SHIP_REQUEST',
        COMBINE_REQUEST = 'COMBINE_REQUEST',
        APPROVE_REQUEST = 'APPROVE_REQUEST',
        REJECT_REQUEST = 'REJECT_REQUEST',
        PACKAGE_RECEIVED = 'PACKAGE_RECEIVED',
        PACKAGE_COMBINED = 'PACKAGE_COMBINED',
        SHIPMENT_CREATED = 'SHIPMENT_CREATED',
        SHIPMENT_UPDATED = 'SHIPMENT_UPDATED',
        SHIPMENT_SHIPPED = 'SHIPMENT_SHIPPED',
        SHIPMENT_DELIVERED = 'SHIPMENT_DELIVERED',
        PAYMENT_CREATED = 'PAYMENT_CREATED',
        PAYMENT_PROCESSED = 'PAYMENT_PROCESSED',
        PAYMENT_COMPLETED = 'PAYMENT_COMPLETED',
        PAYMENT_FAILED = 'PAYMENT_FAILED',
        PAYMENT_REFUNDED = 'PAYMENT_REFUNDED',
        EXPORT = 'EXPORT',
        IMPORT = 'IMPORT',
    }
}

